/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {IFloatingFilterComp, IFloatingFilterParams} from 'ag-grid-community';
import {CustomMultiSelectFilterComponent} from './custom-multi-select-filter.component';

@Component({
    selector: 'app-custom-multi-select-floating-filter',
    template: ``,
    standalone: false
})
export class CustomMultiSelectFloatingFilterComponent implements IFloatingFilterComp {
  eGui!: HTMLDivElement;
  currentValue: any;
  eFilterInput!: HTMLInputElement;

  init(params: IFloatingFilterParams<CustomMultiSelectFilterComponent>) {
    this.eGui = document.createElement('div');

    this.eGui.innerHTML = '<input [(ngModel)]="currentValue" style="width: 100%; margin-top: 4px; margin-bottom: 4px;" disabled/>';
    this.currentValue = null;
    this.eFilterInput = this.eGui.querySelector('input')!;
  }

  onParentModelChanged(parentModel: any) {
    if (parentModel == null || parentModel.length === 0) {
      this.eFilterInput.value = '';
      this.currentValue = null;
    } else {
      // convert parentModel from array of strings to comma separated string
      let values = parentModel.values || parentModel;
      this.eFilterInput.value = (values.length > 1) ? ('(' + values.length + ') ') : '';
      if (parentModel.map) {
        this.eFilterInput.value += values.map((value: any) => value.label ?? value).join(', ');
      } else {
        this.eFilterInput.value += values.join(', ');
      }
      this.currentValue = parentModel;
    }
  }

  getGui() {
    return this.eGui;
  }
}
